import * as api from "../Api";

export const getLocationReceipts = () => async (dispatch) => {
  try {
    const { data } = await api.locationReceipts();
    dispatch({ type: "LOCATION_RECEIPT", payload: data });
  } catch (error) {}
};
